export default "__VITE_ASSET__CUQq3a7m__"